var exports = {
  "kL": "x43aef4ae--c9709c--container",
  "wm": "x43aef4ae--c9709c--logo",
  "yr": "x43aef4ae--c9709c--logo-image",
  "ot": "x43aef4ae--c9709c--logo-icon",
  "Qs": "x43aef4ae--c9709c--content",
  "md": "x43aef4ae--c9709c--nowrap-text",
};

module.exports = exports;
